import clsx from 'clsx'
import { cloneElement, forwardRef } from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const styles = (theme) => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3, 4),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3, 6)
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 8)
    }
  },
  title: {
    marginBottom: theme.spacing(2)
  }
})

const Page = forwardRef(({
  classes,
  children,
  headTitle = '',
  title = '',
  titleComponent,
  ...rest
}, ref) => {
  const element = cloneElement(children, { ref, ...rest })
  const renderedTitle = titleComponent || (
    title &&
    <Typography className={classes.title} color="textPrimary" variant="h1">
      {title}
    </Typography>
  )
  return (
    <>
        <title>{headTitle} - Redirect</title>
      <Container maxWidth={false} className={clsx(classes.root)}>
        <Box display="flex" flexDirection="column" width={1}>
          {renderedTitle}
          {element}
        </Box>
      </Container>
    </>
  )
})

Page.propTypes = {
  children: PropTypes.node.isRequired,
  headTitle: PropTypes.string,
  title: PropTypes.string,
  titleComponent: PropTypes.node
}

export default withStyles(styles)(Page)
